// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3WDyZ","title":"Info_title__2jXPo","links":"Info_links__3WiI0","link":"Info_link__2g9GK","logo":"Info_logo__2KwNz"};